import { KStadiumInstance } from '../../instance';
import {
  HexlantBalanceRes,
  HexlantBalanceDevRes,
  TransactionStateRes,
} from './types';

const SUB_URL = `/octet`;

export const getBalance = () =>
  KStadiumInstance.get<HexlantBalanceRes>(`${SUB_URL}/v2/my/balance`).then(
    (res) => res.data,
  );

// NOTE: 토큰 이름만 바뀌기 때문에 geBalance와 통합 필요
export const getBalanceDev = () =>
  KStadiumInstance.get<HexlantBalanceDevRes>(`${SUB_URL}/v2/my/balance`).then(
    (res) => res.data,
  );
// NOTE: 임시 accessToken 받고 있는데 현재 accessToken과 차이 비교 필요
export const getTransactionStateWithTxHash = (
  accessToken: string,
  txHash: string,
) =>
  KStadiumInstance.get<TransactionStateRes>(
    `${SUB_URL}/transaction?txHash=${txHash}`,
    {
      headers: {
        'X-AUTH-TOKEN': accessToken || ``,
      },
    },
  ).then((res) => res.data);
